module.exports = __webpack_public_path__ + "static/media/icon-auth-flow-2.f6108cd1.png";